<template>
  <section class="detail--ticket--container">
    <div v-if="!loading && !!ticket">
      <b-card :class="{'detail--ticket--admin': isAdmin}" class="mb-0">
        <head-detail
          :ticket="ticket"
          :masterData="masterData"
          @updateTicket="getAllData"
          :colorArray="colorArray"
          :isModal="isModal"
        ></head-detail>
        <div class="d-flex justify-content-end" v-if="viewSwitchProfile">
          <b-form-checkbox switch v-model="setProfileView">Ver como Seller</b-form-checkbox>
        </div>
        <component
          :is="bodyComponent"
          :ticket="ticket"
          :masterData="masterData"
          @updateTicket="getAllData"
        ></component>
      </b-card>
    </div>
    <skeleton-ticket-loader v-else/>
  </section>
</template>

<script>
import BaseServices from '@/store/services/index'
import { ticketDetail } from '@/views/modules/tickets/models/ticketDetail'
import HeadDetail from '@/views/modules/tickets/components/Detail/Head/HeadDetail.vue'
import BodyDetail from '@/views/modules/tickets/components/Detail/Body/BodyDetail.vue'
import BodyDetailAdmin from '@/views/modules/tickets/components/Detail/Body/AdminBodyDetail.vue'
import SkeletonTicketLoader from '@/views/modules/tickets/components/General/SkeletonTicketLoader.vue'

export default {
  props: ['ticketIdModal', 'colorArray', 'isModal'],
  data() {
    return {
      baseService: new BaseServices(this),
      ticket: ticketDetail,
      idTicket: 0,
      masterData: {},
      showMessage: false,
      viewConfig: {
        disabled_answers_notice: {
          button_text: '',
          message: ''
        }
      },
      loading: true,
      setProfileView: false
    }
  },
  components: { HeadDetail, BodyDetail, BodyDetailAdmin, SkeletonTicketLoader },
  computed: {
    dataUser() {
      return this.$session.get('cas_user')
    },
    specialPermissionViewAsSeller() {
      return this.dataUser?.special_permissions?.includes('view-ticket-as-seller')
    },
    conditionViewTicket() {
      return !!this.ticket && !!this.dataUser
    },
    isAdmin() {
      return this.dataUser?.role === 'admin'
    },
    viewSwitchProfile() {
      const emailValid = ['cinthia.garrido@enviame.io', 'jesus.becerra@enviame.io', 'raul.jara@enviame.io']
      return emailValid.includes(this.dataUser?.email)
    },
    bodyComponent() {
      return this.isAdmin && !this.specialPermissionViewAsSeller && !this.setProfileView ? 'BodyDetailAdmin' : 'BodyDetail'
    }
  },
  mounted() {
    this.idTicket = this.$route.params.id ?? this.ticketIdModal
    this.loading = true
    this.checkConditionUser()
  },
  methods: {
    checkConditionUser() {
      if (this.dataUser) {
        this.getAllData()
      } else {
        setTimeout(() => {
          this.$router.go(this.$router.currentRoute)
        }, 1000)
      }
    },
    getAllData() {
      this.ticket = null
      const params = { ticket_id: this.idTicket }
      const queryParams = {
        user_email: this.dataUser.email ?? '',
        timezone: this.dataUser.timezone ?? 'America/Santiago'
      }

      this.baseService.callService('getTicketsDetail', queryParams, params)
        .then(response => {
          this.ticket = { ...response.data[0] }
          this.viewConfig = { ...response.view_config }
          this.getMasterData()
          this.$emit('dataStyleModal', {
            border_color: this.ticket.border_color
          })
          this.showMessage = true
        })
        .catch(err => this.$alert(err))
    },
    getMasterData() {
      const params = { ticket_id: this.idTicket }
      const queryParams = {
        ticket_exists: true,
        role: this.dataUser?.role
      }
      this.baseService.callService('getTicketsMasterData', queryParams, params)
        .then(response => {
          this.masterData = response?.data
          this.setStatus(response?.data?.ticket_statuses || [])
        })
        .catch(err => this.$alert(err))
        .finally(() => {
          this.loading = false
        })
    },
    setStatus(ticket_statuses) {
      const guideTicketStages = []
      this.masterData = {
        ...this.masterData,
        statusFormatted: [],
        stageFormatted: []
      }
      this.masterData.statusFormatted = ticket_statuses ? ticket_statuses.flatMap(el => {
        let response = []
        const conditionalStage = guideTicketStages.includes(el.ticket_stage_code)
        if (!conditionalStage) {
          guideTicketStages.push(el.ticket_stage_code)
          this.masterData.stageFormatted.push({
            text: el.ticket_stage_name,
            id: el.ticket_stage_code
          })
        }
        for (let index = 0; index < el.ticket_sub_statuses.length; index++) {
          const element = el.ticket_sub_statuses[index]
          response = [...response, {
            ...el,
            id: element.code,
            sub_status_code: element.code,
            sub_status_name: element.name,
            text: `${el.complete_name} - ${element.name}`
          }]
        }
        return response
      }) : []
    },
    hideMessage() {
      this.showMessage = false
    }
  }
}
</script>

<style lang="scss">
  .detail--ticket--container {
    max-height: 100vh;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .detail--ticket--admin {
    background-color: #F7FAFC;
  }
</style>
